export enum WorkspaceActivityEventType {
    PRESENTATION_CREATED = "presentation_created",
    SLIDES_CREATED = "slides_created",
    EDITOR_OPENED = "editor_opened",
    CONTENT_EDITED = "content_edited",
    PRESENTATION_SHARED = "presentation_shared",
    PRESENTATION_PRESENTED = "presentation_presented",
    PRESENTATION_EXPORTED = "presentation_exported",
}

export enum WorkspaceActivityMethod {
    TEAM_TEMPLATE = "team_template",
    STARTER_TEMPLATE = "starter_template",
    SHARED_BRAND_KIT = "shared_brand_kit",
    AI_GENERATION = "ai_generation",
    PPT_IMPORT = "ppt_import",
    DUPLICATE = "duplicate",
    OTHER = "other",
    INITIAL = "initial",
    NEW = "new",
    PASTE = "paste",
    PRESENTATION_DUPLICATE = "presentation_duplicate",
    TEAM_SLIDE = "team_slide",
    EDITOR = "editor",
    PRESENTATION = "presentation",
    SLIDE = "slide",
    TEAM_RESOURCE = "team_resource",
    SHARE_LINK = "share_link",
    EMAIL = "email",
    LIBRARY = "library",
    OFFLINE_EXPORT = "offline_export",
    PDF = "pdf",
    PPTX = "pptx",
    GOOGLE_SLIDES = "google_slides",
}

export const WORKSPACE_ACTIVITY_METHODS_BY_EVENT_TYPE: Record<WorkspaceActivityEventType, readonly WorkspaceActivityMethod[]> = {
    [WorkspaceActivityEventType.PRESENTATION_CREATED]: [
        WorkspaceActivityMethod.TEAM_TEMPLATE,
        WorkspaceActivityMethod.STARTER_TEMPLATE,
        WorkspaceActivityMethod.SHARED_BRAND_KIT,
        WorkspaceActivityMethod.AI_GENERATION,
        WorkspaceActivityMethod.PPT_IMPORT,
        WorkspaceActivityMethod.DUPLICATE,
        WorkspaceActivityMethod.OTHER,
    ],
    [WorkspaceActivityEventType.SLIDES_CREATED]: [
        WorkspaceActivityMethod.INITIAL,
        WorkspaceActivityMethod.NEW,
        WorkspaceActivityMethod.DUPLICATE,
        WorkspaceActivityMethod.PASTE,
        WorkspaceActivityMethod.AI_GENERATION,
        WorkspaceActivityMethod.PPT_IMPORT,
        WorkspaceActivityMethod.PRESENTATION_DUPLICATE,
        WorkspaceActivityMethod.TEAM_SLIDE,
    ],
    [WorkspaceActivityEventType.EDITOR_OPENED]: [WorkspaceActivityMethod.EDITOR],
    [WorkspaceActivityEventType.CONTENT_EDITED]: [
        WorkspaceActivityMethod.PRESENTATION,
        WorkspaceActivityMethod.SLIDE,
        WorkspaceActivityMethod.TEAM_RESOURCE,
    ],
    [WorkspaceActivityEventType.PRESENTATION_SHARED]: [
        WorkspaceActivityMethod.SHARE_LINK,
        WorkspaceActivityMethod.EMAIL,
    ],
    [WorkspaceActivityEventType.PRESENTATION_PRESENTED]: [
        WorkspaceActivityMethod.EDITOR,
        WorkspaceActivityMethod.LIBRARY,
        WorkspaceActivityMethod.OFFLINE_EXPORT,
    ],
    [WorkspaceActivityEventType.PRESENTATION_EXPORTED]: [
        WorkspaceActivityMethod.PDF,
        WorkspaceActivityMethod.PPTX,
        WorkspaceActivityMethod.GOOGLE_SLIDES,
        WorkspaceActivityMethod.OTHER,
    ],
};

export type ClientRecordedWorkspaceActivity =
    | {
        eventType: WorkspaceActivityEventType.PRESENTATION_SHARED;
        method: WorkspaceActivityMethod.SHARE_LINK | WorkspaceActivityMethod.EMAIL;
    }
    | {
        eventType: WorkspaceActivityEventType.PRESENTATION_PRESENTED;
        method: WorkspaceActivityMethod.EDITOR | WorkspaceActivityMethod.LIBRARY | WorkspaceActivityMethod.OFFLINE_EXPORT;
    };

export interface IWorkspaceActivityEventInput {
    eventId?: string;
    dedupeKey?: string;
    workspaceId: string;
    actorId: string;
    presentationId?: string | null;
    eventType: WorkspaceActivityEventType;
    method: WorkspaceActivityMethod;
    quantity?: number;
    occurredAt?: Date | string;
    metadata?: Record<string, unknown>;
    source: string;
}

export interface IWorkspaceActivityEvent extends Omit<IWorkspaceActivityEventInput, "eventId" | "dedupeKey" | "occurredAt"> {
    eventId: string;
    dedupeKey: string;
    occurredAt: Date;
    createdAt: Date;
}
